import React, { FC } from 'react';
import { StylesConfig } from 'react-select';
import { AdvancedSelect } from '../select';
import { PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';

export type PropertiesPanelSelectValue = { value: string | number; label: string } | null | undefined;

export type PropertiesPanelAdvancedSelectPropertyProps = {
    menuPlacement?: 'auto' | 'bottom' | 'top';
};

const compactSelectStyles: StylesConfig = {
    container: (provided) => ({
        ...provided,
        width: '100%'
    }),
    control: (provided) => ({
        ...provided,
        minHeight: 28,
        fontSize: 12
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 6px',
        fontSize: 12
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        '& > div': {
            padding: '2px 4px'
        }
    }),
    option: (provided) => ({
        ...provided,
        fontSize: 12,
        padding: '4px 8px'
    })
};

export type PropertiesPanelSelectPropertyProps = {
    id: string;
    label: React.ReactNode;
    options: NonNullable<PropertiesPanelSelectValue>[];
    value: PropertiesPanelSelectValue;
    onChange: (value: PropertiesPanelSelectValue) => void;
    selectCustomProps?: PropertiesPanelAdvancedSelectPropertyProps;
    disabled?: boolean;
};
export const PropertiesPanelSelectProperty: FC<PropertiesPanelSelectPropertyProps> = ({ id, label, options, value, onChange, disabled, selectCustomProps }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <AdvancedSelect
                    id={id}
                    options={options}
                    value={value}
                    onChange={(newValue) => {
                        onChange?.(newValue);
                    }}
                    isDisabled={disabled}
                    styles={compactSelectStyles as any}
                    {...selectCustomProps}
                />
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
